import React from 'react';
import { Button, Dialog, DialogContent, DialogTitle, DialogActions, Grid } from '@material-ui/core';
import moment from 'moment';

function CalendarEventInfo({ event, showModal, MODAL_TYPE }) {
    return (
        <Dialog
            aria-labelledby="calendar-event-info-modal"
            maxWidth="sm"
            open
            onClose={() => showModal(MODAL_TYPE.NONE)}
        >
            <DialogTitle>{moment(event.activity_start).format('MMM, DD H:mm A')}</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item>
                        <span className="event-dialog-name">{event.activity?.name}</span>
                        <br />
                        <span className="event-dialog-status">Status: {event.status}</span>
                        <br />
                        <span className="event-dialog-tickets">
                            Tickets:
                            <br />
                            {event.tickets.map(t => `${t.quantity}x ${t.name}`).join('\n')}
                        </span>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => showModal(MODAL_TYPE.NONE)}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default CalendarEventInfo;
